import linkLogo from "../../assets/logo.png";

import BoletimSection from "../BoletimSection/BoletimSection";
import CardImageGrid from "../CardImageGrid/CardImageGrid";

function Nivelamento({ nivelamentos }) {
	const NIVELAMENTO_OPTIONS = [
        {
            desc: `Matemática ${Object.keys(nivelamentos).includes("matematica") ? nivelamentos['matematica'] : ''}`,
            image: linkLogo,
            disabled: Object.keys(nivelamentos).includes("matematica") ? false : true,
            show: true,
        },
		{
			desc: `Inglês ${Object.keys(nivelamentos).includes("ingles") ? nivelamentos['ingles'] : ''}`,
			image: linkLogo,
			disabled: Object.keys(nivelamentos).includes("ingles") ? false : true,
            show: true,
		},
	];
	return (
		<BoletimSection
			title="Nivelamento"
			icon="ventures"
		>
			<CardImageGrid
				type={"nivelamento"}
				items={NIVELAMENTO_OPTIONS}
                imageStyles={{ width: "85%", padding: "24px" }}
			/>
		</BoletimSection>
	);
}

export default Nivelamento;
